const url = import.meta.env.VITE_APP_API_TRADE

function addOrder(list,data) {
    list.push({
        "volume": data.v,
        "remain_volume": data.v,
        "price": data.p,
    })
}

export default {
    actions: {
        async fetchOrders({commit, getters}, ) {

            const direction  = getters.getActiveTool.direction;
            commit('SET_ORDER_LOADING_STATUS', 'loading')
            const  resJson = await fetch(`${url}/order/list/${direction}`)
            const res = await resJson.json()
            if(res.code === 200) {
                commit('SET_ORDERS_SELL', res.data.sell)
                commit('SET_ORDERS_BUY', res.data.buy)
                commit('SET_CURRENT_DIRECTION', direction)
                commit('SET_ORDER_LOADING_STATUS', 'success')
            } else {
                commit('SET_ORDER_LOADING_STATUS', 'error')
            }
        },
    },
    mutations: {
        SET_ORDERS_SELL(state, orders) {
            state.ordersSell = orders
        },
        SET_ORDERS_BUY(state, orders) {
            state.ordersBuy = orders
        },
        SET_ORDER_LOADING_STATUS(state, status) {
            state.orderLoadingStatus = status
        },
        SET_CURRENT_DIRECTION(state, name) {
            state.currentDirection = name
        },
        SOCKET_ONMESSAGE(state, message) {

            if(state.currentDirection === null || state.currentDirection !=  message.d) {
                return;
            }
            const type = message.t == "ob" ? "ordersBuy" :  message.t == "os" ? "ordersSell" : undefined
            if(type === undefined) {
                return
            }
            const foundIndex =  state[type].findIndex(el => el.price == message.p)
            let orders = state[type]
            if(foundIndex === -1) {
                addOrder(orders, message)
                return
            }
            let volume = 0
            if(message.s == "bm") {
                volume = parseFloat((orders[foundIndex].remain_volume + message.v).toFixed(8))
            } else if(message.s == "am") {
                volume = parseFloat((orders[foundIndex].remain_volume - message.v).toFixed(8))
            }
            if(volume <= 0) {
                orders.splice(foundIndex, 1)
            } else {
                orders[foundIndex].remain_volume = volume
            }
        },
    },
    state: {
        currentDirection: null,
        orderLoadingStatus: 'loading',
        ordersBuy: [],
        ordersSell: [],
    },
    getters: {
        orders:(state) => [...state.ordersBuy, ...state.ordersSell],
        ordersBuy:(state) => state.ordersBuy,
        ordersSell:(state) => state.ordersSell,
        orderLoadingStatus:(state) => state.orderLoadingStatus,
    },
}